import React from 'react';

import { type Money, formatMoney } from '@betterment/js-runtime';
import { Text, type TextColorToken } from '@betterment/samba-react';

import { formatNumberWithDecimals } from '../../utils/NumbersHelper';

type Props = {
  amount: Money;
  percent: number;
  negativeToken?: TextColorToken;
} & React.ComponentProps<typeof Text>;

export const ReturnsText: React.FC<Props> = ({ amount, percent, negativeToken, ...textProps }) => {
  const sign = (value: number) => (value > 0 ? '+' : '');
  const color: TextColorToken = (() => {
    if (amount.cents > 0) return 'text.success';
    if (amount.cents < 0) return negativeToken || 'text.critical';
    return 'text.weak';
  })();

  const formattedAmount = `${sign(amount.cents)}${formatMoney(amount)}`;
  const formattedPercent = `${sign(percent)}${formatNumberWithDecimals(percent, 2)}%`;

  return (
    <Text variant="text50" color={color} {...textProps}>
      {`${formattedAmount} (${formattedPercent})`}
    </Text>
  );
};
